import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../../lib/result-codes";
import {
  updateMerchantCoupon as updateMerchantCouponApi,
  uploadCouponImage,
} from "../api/merchantCouponEditor.api";
import { MERCHANT_COUPON_NOTIFICATION_MESSAGES } from "../data/merchantCouponEditor.constants";
import type { MerchantCouponUIState } from "../data/merchantCouponEditor.data";

interface UseUpdateMerchantCouponReturn {
  updateMerchantCoupon: (couponId: string, coupon: MerchantCouponUIState) => Promise<void>;
  loading: boolean;
  error: string | null;
}

export const useUpdateMerchantCoupon = (): UseUpdateMerchantCouponReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateMerchantCoupon = useCallback(
    async (couponId: string, coupon: MerchantCouponUIState): Promise<void> => {
      try {
        setLoading(true);
        setError(null);

        let imageUrl = coupon.image_url;
        if (coupon.image_file && coupon.image_file instanceof File) {
          imageUrl = await uploadCouponImage(coupon.image_file);
        }

        await updateMerchantCouponApi(couponId, {
          ...coupon,
          image_url: imageUrl,
          image_file: undefined,
        });
      } catch (updateError: unknown) {
        setError(
          getApiErrorMessage(updateError, MERCHANT_COUPON_NOTIFICATION_MESSAGES.UPDATE_ERROR),
        );
        throw updateError;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { updateMerchantCoupon, loading, error };
};
